export const isValidUsername = (value: string) => value.length >= 3;
